import { render } from "./Affix.vue?vue&type=template&id=b094ec98"
import script from "./Affix.vue?vue&type=script&lang=ts"
export * from "./Affix.vue?vue&type=script&lang=ts"
script.render = render

export default script